import React from 'react';

import Dropping from 'components/pages/home/dropping';
import FAQ from 'components/pages/home/faq';
import Hero from 'components/pages/home/hero';
import HowItWorks from 'components/pages/home/how-it-works';
import Mission from 'components/pages/home/mission';
import Offer from 'components/pages/home/offer';
import PictureThis from 'components/pages/home/picture-this';
import Resources from 'components/pages/home/resources';
import StartHere from 'components/pages/home/start-here';
import Stores from 'components/pages/home/stores';
import Ticker from 'components/pages/home/ticker';
import MainLayout from 'layouts/main';

const Home = () => {
  return (
    <MainLayout>
      <Hero />
      <Ticker />
      <Mission />
      <PictureThis />
      <Dropping />
      <Resources />
      <StartHere />
      <HowItWorks />
      <Offer />
      <Stores />
      <FAQ />
    </MainLayout>
  );
};

export default Home;
